import { FontWeightTokenValue } from 'designSystem/types';
import * as S from './styles';

interface FontWeightTokenPreviewProps {
	value: FontWeightTokenValue;
}

export const FontWeightTokenPreview = ({ value }: FontWeightTokenPreviewProps) => {
	return (
		<S.PreviewContainer>
			<S.WeightSample fontWeight={value.numeric}>Sample Text</S.WeightSample>
			<S.ValueText>{value.keyword || value.numeric}</S.ValueText>
		</S.PreviewContainer>
	);
};
